import type { CFaqTranslations } from "./pl";

export const de: CFaqTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyList: "In diesem Bereich gibt es derzeit keine Einträge.",
  formatQuestion: (index, question) => `${index}. ${question}`,
  searchLabel: "Fragen durchsuchen",
  searchPlaceholder: "Tippen, um Fragen zu filtern…",
  formatEmptyResults: (query) => `Keine Fragen entsprechen „${query}".`,
};
